import { StyledTableContainer } from './styles'

export const TableContainer = ({ maxHeight = '552px', ...props }) => {
  return <StyledTableContainer sx={{ maxHeight }} {...props} />
}
